module.exports = __webpack_public_path__ + "fonts/CashSans-RegularItl.2b4521d.woff2";